// src/modules/Caregaps2/index.js
import CareGapsPageContainer from "./pages/CareGapsPageContainer";

export default CareGapsPageContainer;
